var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertiesbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1402,
    height: 483,
    viewBox: "0 0 1402 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .left-edge-run {\n    stroke-dasharray: 140 520;\n    stroke-dashoffset: 0;\n    stroke-linecap: round;\n    animation: leftEdgeRun 9s linear infinite;\n  }\n  .right-edge-run {\n    stroke-dasharray: 140 520;\n    stroke-dashoffset: 0;\n    stroke-linecap: round;\n    animation: rightEdgeRun 9s linear infinite;\n  }\n  @keyframes leftEdgeRun {\n    from { stroke-dashoffset: 0; }\n    to { stroke-dashoffset: -644; }\n  }\n  @keyframes rightEdgeRun {\n    from { stroke-dashoffset: 0; }\n    to { stroke-dashoffset: 644; }\n  }\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: 160.5,
    width: 161,
    height: 161,
    stroke: "url(#paint0_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: 321.5,
    width: 161,
    height: 161,
    stroke: "url(#paint1_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    stroke: "url(#paint2_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 161.5,
    y: -0.5,
    width: 161,
    height: 161,
    stroke: "url(#paint3_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 322.5,
    y: -0.5,
    width: 161,
    height: 161,
    stroke: "url(#paint4_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 161.5,
    y: 160.5,
    width: 161,
    height: 161,
    stroke: "url(#paint5_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 322.5,
    y: 160.5,
    width: 161,
    height: 161,
    stroke: "url(#paint6_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "left-edge-run",
    opacity: 0.6,
    x: 161.5,
    y: 321.5,
    width: 161,
    height: 161,
    stroke: "url(#paint7_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "left-edge-run",
    opacity: 0.6,
    d: "M324 321.5V322H326V321.5H328V322H330V321.5H332V322H334V321.5H336V322H338V321.5H340V322H342V321.5H344V322H346V321.5H348V322H350V321.5H352V322H354V321.5H356V322H358V321.5H360V322H362V321.5H364V322H366V321.5H368V322H370V321.5H372V322H374V321.5H376V322H378V321.5H380V322H382V321.5H384V322H386V321.5H388V322H390V321.5H392V322H394V321.5H396V322H398V321.5H400V322H402V321.5H404V322H406V321.5H408V322H410V321.5H412V322H414V321.5H416V322H418V321.5H420V322H422V321.5H424V322H426V321.5H428V322H430V321.5H432V322H434V321.5H436V322H438V321.5H440V322H442V321.5H444V322H446V321.5H448V322H450V321.5H452V322H454V321.5H456V322H458V321.5H460V322H462V321.5H464V322H466V321.5H468V322H470V321.5H472V322H474V321.5H476V322H478V321.5H480V322H482V321.5H483.5V323H483V325H483.5V327H483V329H483.5V331H483V333H483.5V335H483V337H483.5V339H483V341H483.5V343H483V345H483.5V347H483V349H483.5V351H483V353H483.5V355H483V357H483.5V359H483V361H483.5V363H483V365H483.5V367H483V369H483.5V371H483V373H483.5V375H483V377H483.5V379H483V381H483.5V383H483V385H483.5V387H483V389H483.5V391H483V393H483.5V395H483V397H483.5V399H483V401H483.5V403H483V405H483.5V407H483V409H483.5V411H483V413H483.5V415H483V417H483.5V419H483V421H483.5V423H483V425H483.5V427H483V429H483.5V431H483V433H483.5V435H483V437H483.5V439H483V441H483.5V443H483V445H483.5V447H483V449H483.5V451H483V453H483.5V455H483V457H483.5V459H483V461H483.5V463H483V465H483.5V467H483V469H483.5V471H483V473H483.5V475H483V477H483.5V479H483V481H483.5V482.5H482V482H480V482.5H478V482H476V482.5H474V482H472V482.5H470V482H468V482.5H466V482H464V482.5H462V482H460V482.5H458V482H456V482.5H454V482H452V482.5H450V482H448V482.5H446V482H444V482.5H442V482H440V482.5H438V482H436V482.5H434V482H432V482.5H430V482H428V482.5H426V482H424V482.5H422V482H420V482.5H418V482H416V482.5H414V482H412V482.5H410V482H408V482.5H406V482H404V482.5H402V482H400V482.5H398V482H396V482.5H394V482H392V482.5H390V482H388V482.5H386V482H384V482.5H382V482H380V482.5H378V482H376V482.5H374V482H372V482.5H370V482H368V482.5H366V482H364V482.5H362V482H360V482.5H358V482H356V482.5H354V482H352V482.5H350V482H348V482.5H346V482H344V482.5H342V482H340V482.5H338V482H336V482.5H334V482H332V482.5H330V482H328V482.5H326V482H324V482.5H322.5V481H323V479H322.5V477H323V475H322.5V473H323V471H322.5V469H323V467H322.5V465H323V463H322.5V461H323V459H322.5V457H323V455H322.5V453H323V451H322.5V449H323V447H322.5V445H323V443H322.5V441H323V439H322.5V437H323V435H322.5V433H323V431H322.5V429H323V427H322.5V425H323V423H322.5V421H323V419H322.5V417H323V415H322.5V413H323V411H322.5V409H323V407H322.5V405H323V403H322.5V401H323V399H322.5V397H323V395H322.5V393H323V391H322.5V389H323V387H322.5V385H323V383H322.5V381H323V379H322.5V377H323V375H322.5V373H323V371H322.5V369H323V367H322.5V365H323V363H322.5V361H323V359H322.5V357H323V355H322.5V353H323V351H322.5V349H323V347H322.5V345H323V343H322.5V341H323V339H322.5V337H323V335H322.5V333H323V331H322.5V329H323V327H322.5V325H323V323H322.5V321.5H324Z",
    stroke: "url(#paint8_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1402 161)",
    stroke: "url(#paint9_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1402 322)",
    stroke: "url(#paint10_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1402 0)",
    stroke: "url(#paint11_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1241 0)",
    stroke: "url(#paint12_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1080 0)",
    stroke: "url(#paint13_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1241 161)",
    stroke: "url(#paint14_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1080 161)",
    stroke: "url(#paint15_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "right-edge-run",
    opacity: 0.6,
    x: 0.5,
    y: -0.5,
    width: 161,
    height: 161,
    transform: "matrix(-1 0 0 1 1241 322)",
    stroke: "url(#paint16_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "right-edge-run",
    opacity: 0.6,
    d: "M1078 321.5V322H1076V321.5H1074V322H1072V321.5H1070V322H1068V321.5H1066V322H1064V321.5H1062V322H1060V321.5H1058V322H1056V321.5H1054V322H1052V321.5H1050V322H1048V321.5H1046V322H1044V321.5H1042V322H1040V321.5H1038V322H1036V321.5H1034V322H1032V321.5H1030V322H1028V321.5H1026V322H1024V321.5H1022V322H1020V321.5H1018V322H1016V321.5H1014V322H1012V321.5H1010V322H1008V321.5H1006V322H1004V321.5H1002V322H1000V321.5H998V322H996V321.5H994V322H992V321.5H990V322H988V321.5H986V322H984V321.5H982V322H980V321.5H978V322H976V321.5H974V322H972V321.5H970V322H968V321.5H966V322H964V321.5H962V322H960V321.5H958V322H956V321.5H954V322H952V321.5H950V322H948V321.5H946V322H944V321.5H942V322H940V321.5H938V322H936V321.5H934V322H932V321.5H930V322H928V321.5H926V322H924V321.5H922V322H920V321.5H918.5V323H919V325H918.5V327H919V329H918.5V331H919V333H918.5V335H919V337H918.5V339H919V341H918.5V343H919V345H918.5V347H919V349H918.5V351H919V353H918.5V355H919V357H918.5V359H919V361H918.5V363H919V365H918.5V367H919V369H918.5V371H919V373H918.5V375H919V377H918.5V379H919V381H918.5V383H919V385H918.5V387H919V389H918.5V391H919V393H918.5V395H919V397H918.5V399H919V401H918.5V403H919V405H918.5V407H919V409H918.5V411H919V413H918.5V415H919V417H918.5V419H919V421H918.5V423H919V425H918.5V427H919V429H918.5V431H919V433H918.5V435H919V437H918.5V439H919V441H918.5V443H919V445H918.5V447H919V449H918.5V451H919V453H918.5V455H919V457H918.5V459H919V461H918.5V463H919V465H918.5V467H919V469H918.5V471H919V473H918.5V475H919V477H918.5V479H919V481H918.5V482.5H920V482H922V482.5H924V482H926V482.5H928V482H930V482.5H932V482H934V482.5H936V482H938V482.5H940V482H942V482.5H944V482H946V482.5H948V482H950V482.5H952V482H954V482.5H956V482H958V482.5H960V482H962V482.5H964V482H966V482.5H968V482H970V482.5H972V482H974V482.5H976V482H978V482.5H980V482H982V482.5H984V482H986V482.5H988V482H990V482.5H992V482H994V482.5H996V482H998V482.5H1000V482H1002V482.5H1004V482H1006V482.5H1008V482H1010V482.5H1012V482H1014V482.5H1016V482H1018V482.5H1020V482H1022V482.5H1024V482H1026V482.5H1028V482H1030V482.5H1032V482H1034V482.5H1036V482H1038V482.5H1040V482H1042V482.5H1044V482H1046V482.5H1048V482H1050V482.5H1052V482H1054V482.5H1056V482H1058V482.5H1060V482H1062V482.5H1064V482H1066V482.5H1068V482H1070V482.5H1072V482H1074V482.5H1076V482H1078V482.5H1079.5V481H1079V479H1079.5V477H1079V475H1079.5V473H1079V471H1079.5V469H1079V467H1079.5V465H1079V463H1079.5V461H1079V459H1079.5V457H1079V455H1079.5V453H1079V451H1079.5V449H1079V447H1079.5V445H1079V443H1079.5V441H1079V439H1079.5V437H1079V435H1079.5V433H1079V431H1079.5V429H1079V427H1079.5V425H1079V423H1079.5V421H1079V419H1079.5V417H1079V415H1079.5V413H1079V411H1079.5V409H1079V407H1079.5V405H1079V403H1079.5V401H1079V399H1079.5V397H1079V395H1079.5V393H1079V391H1079.5V389H1079V387H1079.5V385H1079V383H1079.5V381H1079V379H1079.5V377H1079V375H1079.5V373H1079V371H1079.5V369H1079V367H1079.5V365H1079V363H1079.5V361H1079V359H1079.5V357H1079V355H1079.5V353H1079V351H1079.5V349H1079V347H1079.5V345H1079V343H1079.5V341H1079V339H1079.5V337H1079V335H1079.5V333H1079V331H1079.5V329H1079V327H1079.5V325H1079V323H1079.5V321.5H1078Z",
    stroke: "url(#paint17_linear_1247_57)",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1247_57)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 701,
    rx: 340,
    ry: 100,
    fill: "#744DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1247_57",
    x: 11,
    y: -450,
    width: 1380,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_1247_57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1247_57",
    x1: 45.5283,
    y1: 251.667,
    x2: 0.403388,
    y2: 320.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1247_57",
    x1: 69,
    y1: 402.762,
    x2: 0.61027,
    y2: 481.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1247_57",
    x1: 128.2,
    y1: 127.238,
    x2: 0.109149,
    y2: 156.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1247_57",
    x1: 242,
    y1: 0,
    x2: 242,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1247_57",
    x1: 415,
    y1: 101.333,
    x2: 479.997,
    y2: 163.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1247_57",
    x1: 206.528,
    y1: 251.667,
    x2: 161.403,
    y2: 320.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1247_57",
    x1: 389.4,
    y1: 207.476,
    x2: 359.585,
    y2: 320.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1247_57",
    x1: 242,
    y1: 351.714,
    x2: 235.413,
    y2: 481.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1247_57",
    x1: 395.8,
    y1: 418.762,
    x2: 466.459,
    y2: 494.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1247_57",
    x1: 44.5283,
    y1: 90.6667,
    x2: -0.596612,
    y2: 159.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1247_57",
    x1: 68,
    y1: 80.7619,
    x2: -0.38973,
    y2: 159.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1247_57",
    x1: 127.2,
    y1: 127.238,
    x2: -0.890851,
    y2: 156.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1247_57",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1247_57",
    x1: 92,
    y1: 101.333,
    x2: 156.997,
    y2: 163.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1247_57",
    x1: 44.5283,
    y1: 90.6667,
    x2: -0.596612,
    y2: 159.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1247_57",
    x1: 66.4,
    y1: 46.4762,
    x2: 36.5848,
    y2: 159.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1247_57",
    x1: 80,
    y1: 29.7143,
    x2: 73.4125,
    y2: 159.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1247_57",
    x1: 1006.2,
    y1: 418.762,
    x2: 935.541,
    y2: 494.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertiesbg);
export default __webpack_public_path__ + "static/media/expertiesbg.945e9fcd49921c63c5f7e4799d8d46c4.svg";
export { ForwardRef as ReactComponent };